"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const page_1 = require("../nodes/page");
const sort_1 = require("../nodes/sort");
const aggregate_1 = require("../nodes/aggregate");
const filter_1 = require("../nodes/filter");
const grain_filter_1 = require("../nodes/grain-filter");
const signature_1 = require("../signature");
class QueryHelper {
    constructor(node, datasetRepo) {
        this.node = node;
        this.datasetRepo = datasetRepo;
    }
    filter(columnName, test, value) {
        let columnSig = this.node.lookupColumn(columnName, this.datasetRepo);
        let filterNode = new filter_1.default(columnSig, test, value);
        this.node.connect(filterNode);
        this.node = filterNode;
        return this;
    }
    filterGrain(sourceName, columnName, test, value) {
        let grainSig = new signature_1.GrainSignature(sourceName, columnName);
        let filterNode = new grain_filter_1.default(grainSig, test, value);
        this.node.connect(filterNode);
        this.node = filterNode;
        return this;
    }
    sort(columnName, asc = true) {
        let columnSig = this.node.lookupColumn(columnName, this.datasetRepo);
        let sortNode = new sort_1.default(columnSig, asc);
        this.node.connect(sortNode);
        this.node = sortNode;
        return this;
    }
    paginate(pageSize, page = 0) {
        let pageNode = new page_1.default(pageSize, page);
        this.node.connect(pageNode);
        this.node = pageNode;
        return this;
    }
    aggregate(columns, func) {
        if (typeof columns === 'string')
            columns = [columns];
        let aggregations = columns.map(column => {
            let colSig = this.node.lookupColumn(column, this.datasetRepo);
            return new aggregate_1.AggregationSignature(colSig, func);
        });
        if (this.node instanceof aggregate_1.default) {
            for (let aggregation of aggregations)
                this.node.aggregations.push(aggregation);
        }
        else {
            let aggNode = new aggregate_1.default(aggregations);
            this.node.connect(aggNode);
            this.node = aggNode;
        }
        return this;
    }
    build() {
        return this.node;
    }
}
exports.default = QueryHelper;
